.container {
  border-radius: 0.75rem;
  /* rounded-xl */
  border: 1px solid #62748E;

  // border: 1px solid #e5e7eb;
  background: #ffffff;
  overflow: hidden;
  /* overflow-hidden */
}

.headerBg {
  border-bottom: 1px solid #E4E4E7;
  background: #DBEAFE;

  .headerCell {
    color: #020618;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
  }
}

.cell {
  color: #09090B;
  text-overflow: ellipsis;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0;
}

.cellRight {
  text-align: right;
}

.emptyRow {
  text-align: center;
  padding: 1rem 0;
  color: #6b7280;
}

.oddRow {
  background: #ffffff;
}

.evenRow {
  background: #F9FAFB;
}